import React from "react";

interface ComingSoonProps {
  title: string;
  description?: string;
}

export default function ComingSoon({ title, description }: ComingSoonProps) {
  return (
    <div className="p-8 h-full w-full flex items-center justify-center">
      <div className="max-w-xl text-center">
        <div className="text-5xl mb-4">🚧</div>
        <h1 className="text-2xl font-semibold mb-2">{title} (Coming Soon)</h1>
        <p className="text-muted-foreground">
          {description || "This module is planned and will appear here when ready."}
        </p>
      </div>
    </div>
  );
}


